import {
  StyleSheet,
  css,
  StyleDeclarationMap,
  CSSProperties,
} from '../../../styleSheet';
import {DependencyList, useMemo} from 'react';
import {isEmptyStyle} from '../functions';

export const useStyle = (
  styleFactory: () => CSSProperties | StyleDeclarationMap,
  deps: DependencyList,
): string => {
  const stylesheet = useMemo(() => {
    const styles = styleFactory();

    return StyleSheet.create({di: styles});
    // TODO: Do we need a factory?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return useMemo(() => (!isEmptyStyle(stylesheet) ? css(stylesheet.di) : ''), [
    stylesheet,
  ]);
};
